//项目名称
//export const PROJECTNAME="";
export const PROJECTNAME="/zqyl_manager";
export const PROJECTNAMEAPI="/zqyl-manager-api";
export const PREFIX="data:image/png;base64,";


const UEDITOR_HOME_URL = process.env.NODE_ENV === 'development' ? '/UE/' : PROJECTNAME + '/UE/'
export const UEDITORCONFIG={
	UEDITOR_HOME_URL,
	elementPathEnabled:false,
	BaseUrl: '',
	imageUrlPrefix: location.protocol+"//"+location.host+PROJECTNAME, // 图片路径前缀
	autoHeightEnabled: false,
	autoFloatEnabled: true,
	initialContent:'',   //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
	autoClearinitialContent:false, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
	initialFrameWidth: null, // 编辑器宽度
	initialFrameHeight: 450, // 编辑器高度
	// BaseUrl: '',
	// UEDITOR_HOME_URL: 'static/ueditor/'
}
export const SEARCHBUTTONTEXT="搜索";
//loading加载配置参数
export const LOADING={
	lock: true,
	text: 'Loading',
	spinner: 'el-icon-loading',
	background: 'rgba(0, 0, 0, 0.7)'
}
//状态码
export const STATUSCODE={
	code01:'M0200',
	code02:'M0300',
	code03:'M0500',
	code04:"M0760"
};
//今天及今天之后
export const beforeToday={
	disabledDate(time){
		return time.getTime() > Date.now() - 8.64e6;
	}
};
//今天及今天之前
export const afterToday={
	disabledDate(time){
		return time.getTime() < Date.now() - 8.64e7;
	}
};
export const pickerOptions={
	shortcuts: [{
		text: '最近一个月',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			picker.$emit('pick', [start, end]);
		}
	},{
		text: '最近三个月',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			picker.$emit('pick', [start, end]);
		}
	},{
		text: '最近半年',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
			picker.$emit('pick', [start, end]);
		}
	},{
		text: '最近一年',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
			picker.$emit('pick', [start, end]);
		}
	},{
		text: '无固定期限',
		onClick(picker) {
			const end = new Date();
			const start = new Date();
			end.setTime(4070880000000);
			picker.$emit('pick', [start, end]);
		}
	}]
};
